import { AxiosBookings, orgId } from "../apiConfig";
import { appendQueryParams } from "../../utilities/urlUtils";

export const consolidationsApiFactory = {
  $_getConsolidations(params) {
    const url = `/consolidation/org/${orgId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  $_searchConsolidations(params) {
    const url = `/consolidation/search/${orgId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },

  $_createConsolidation(payload) {
    const url = "/consolidation";
    return AxiosBookings.post(url, payload);
  },

  $_modifyConsolidation(consolidationId, payload) {
    const url = `/consolidation/${consolidationId}`;
    return AxiosBookings.patch(url, payload);
  },

  $_cancelConsolidation(consolidationId) {
    const url = `/consolidation/${orgId()}/${consolidationId}`;
    return AxiosBookings.delete(url);
  },

  $_newCancelConsolidation(consolidationId, payload) {
    const url = `/consolidation/cancel/${consolidationId}`;
    return AxiosBookings.delete(url, { data: payload });
  },

  $_viewManifest(fleetId) {
    const url = `/fleets/assigned/${fleetId}`;
    return AxiosBookings.get(url);
  },
  $_removeConsolidation(payload) {
    const url = `/consolidation/shipments/remove`;
    return AxiosBookings.patch(url, payload);
  },
  $_getConsolidation(id) {
    const url = `/consolidation/one/${id}`;
    return AxiosBookings.get(url);
  },

  $_getShippingServices() {
    const url = `/shippingservices/org/${orgId()}`;
    return AxiosBookings.get(url);
  },
  $_getConsolidationStatusList() {
    const url = "/consolidation/status-list";
    return AxiosBookings.get(url);
  },
  $_createConsolidationNew(payload) {
    const url = "/consolidation/receiver";
    return AxiosBookings.post(url, payload);
  },
  $_newGetConsolidationRoutes() {
    const url = `/consolidation/routes/${orgId()}`;
    return AxiosBookings.get(url);
  },
  $_newGetConsolidationShipments(params) {
    const url = `/consolidation/shipments/${orgId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  $_newGetConsolidationFleets(params) {
    const url = `/consolidation/fleets/${orgId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  $_newGetConsolidationVehicles() {
    const url = `/consolidation/vehicles/${orgId()}`;
    return AxiosBookings.get(url);
  },
  $_newCreateConsolidation(payload) {
    const url = `/consolidation/create`;
    return AxiosBookings.post(url, payload);
  },
  $_newGetConsolidations() {
    const url = `/consolidation/org/${orgId()}`;
    return AxiosBookings.get(url);
  },
  $_updateConsolidationShippingStatus(shippingId, payload) {
    const url = `/consolidation/shipment-status/${shippingId}`;
    return AxiosBookings.patch(url, payload);
  },
  $_getmanifestDetails(conmsolidationid, params) {
    const url = `/consolidation/manifest/${conmsolidationid}${appendQueryParams({ orgId: orgId(), ...params })}`;
    return AxiosBookings.get(url);
  },
  $_updateConsolidationDispatch(payload) {
    const url = `/dispatch/long-haul/create/${orgId()}`;
    return AxiosBookings.post(url, payload);
  },
  $_getConsolidationAnalytics() {
    const url = `/consolidation/analytics/${orgId()}`;
    return AxiosBookings.get(url);
  },
  $_getConsolidationShippingId(id) {
    const url = `/consolidation/shipment-details/${id}`;
    return AxiosBookings.get(url);
  },
  $_getmanifestDispatchDetails(disptchId, params) {
    const url = `/dispatch/manifest/${disptchId}${appendQueryParams({ ...params })}`;
    return AxiosBookings.get(url);
  },
};
